<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <hs-security-generic-transfer
    #generic
    [transInput]="transInput"
    [genericData]="genericData"
    [errorText]="errorText"
    [aggregateAccountUnresolved]="aggregateAccountUnresolved"
    [sleeveSimpleAccount]="sleeveSimpleAccount"
    (transferDateSync)="transferDateSync($event)"
    (transferPriceSync)="transferPriceSync($event)"
    (validUnitChange)="validUnitChange($event)"
    (transferTypeChanged)="transferTypeChanged($event)"
    (securityDetailsUpdated)="securityDetailsUpdated($event)"
    (sleeveAccountDetails)="updateSleeveAccountsOnChange($event)"
    (genericFieldChanged)="validate()"
    (isCollateralAccount)="isCollateralBrokerAccount = $event"
    (allLoadedGeneric)="allLoadedGeneric()"
    (isDataInvalidated)="invalidateData()"
    (editingStarted)="editingStarted()"
    (editingStopped)="editingStopped()"
    (errorDetails)="setErrorDetails($event)"
    (errorHeader)="setErrorHeader($event)"
    (pricesChangeByUnit)="pricesChangeByUnit()"
    (gridFocused)="handleGridFocusChange($event)"
  ></hs-security-generic-transfer>
  <ngb-accordion [destroyOnHide]="false">
    <ngb-panel title="Basis Specific Details">
      <ng-template ngbPanelContent>
        <hs-security-basis-transfer
          #basis
          [transInput]="transInput"
          [basisData]="basisData"
          [hplMode]="applyHPL"
          [aggregateAccountUnresolved]="aggregateAccountUnresolved"
          (costChanged)="calculatePrice($event)"
          (basisFieldChanged)="validate()"
          (allLoadedBasis)="allLoadedBasis()"
          (editingStarted)="editingStarted()"
          (editingStopped)="editingStopped()"
          (gridFocused)="handleGridFocusChange($event)"
        ></hs-security-basis-transfer>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
  <nf-form-control
    class="notes-control"
    label="Notes"
    [customErrorMessages]="getFieldValidatorFormatter('transactionNote')"
    [warnings]="noteWarning"
  >
    <textarea
      id="notesText"
      class="form-control"
      ngbAutofocus
      rows="3"
      [formControl]="note"
      (focus)="disableGridFocus()"
    ></textarea>
  </nf-form-control>

  <nf-form-control
    class="forbidden-control"
    label="Missing Permissions : "
    [customErrorMessages]="getFieldValidatorFormatter('forbiddenErrors')"
    [hidden]="!forbiddenErrors.errors"
  >
    <p id="forbiddenText" class="form-control">{{ forbiddenErrors.value }}</p>
  </nf-form-control>
  <div
    *ngFor="let genericWarning of genericWarnings"
    [hidden]="genericWarnings.size == 0"
  >
    <span class="mdi mdi-alert-circle-outline text-warning genericIcon"></span>
    <span class="info">{{ genericWarning }}</span>
  </div>
  <hs-dialog-error-details
    [errorHeader]="errorHeader"
    [errorDetails]="errorDetails"
  ></hs-dialog-error-details>
</div>
<div class="modal-footer d-flex align-items-center" hsDraggable="modal-dialog">
  <div class="mr-3">
    <nf-checkbox
      [formControl]="clearTransaction"
      label="Clear Transaction"
    ></nf-checkbox>
  </div>
  <div class="mr-3">
    <nf-checkbox
      [formControl]="reprocessTransfers"
      label="Reprocess Downstream Transfers"
    ></nf-checkbox>
  </div>

  <div class="flex-grow-1 text-right">
    <span *ngIf="isValidating" class="mdi mdi-loading">validating..</span>
    <span *ngIf="isCalculatingFactor" class="mdi mdi-loading"
      >Loading Calculated Factor..</span
    >
    <button
      nf-button="cancel"
      (click)="useCalculatedFactor()"
      [disabled]="origSettleDateValidationError"
    >
      Use Calculated Factor
    </button>
    <button
      nf-button="cancel"
      (click)="requestPrice()"
      [disabled]="this.isEdit"
    >
      Request External Price
    </button>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      *ngIf="!transInput?.readOnly"
      nf-button="submit"
      placement="left-top"
      [ngbTooltip]="
        !isEdit && loadedForNonDefaultBasis
          ? 'LIB Transfers need to be processed via the Cost Data tool.'
          : ''
      "
      [disabled]="
        (!isEdit && loadedForNonDefaultBasis) || !isDataValid || isCellEditing
      "
      (click)="validateAndSave()"
    >
      Save
    </button>
  </div>
</div>
